import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";
import "./Header.css";
import { useHistory, Link } from "react-router-dom";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const history = useHistory();

  const logout = () => {
    // Implement the logout logic
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    // Redirect to the home page or login page
    history.push("/login");
  };

  const routeToLogin = () => {
    history.push("/login");
    // Implement the logic to navigate to the login page
  };

  const routeToRegister = () => {
    history.push("/register");
    // Implement the logic to navigate to the register page
  };

  const routeToExplore = () => {
    history.push("/");
    // Implement the logic to navigate to the explore page
  };

  if (hasHiddenAuthButtons) {
    return (
      <Box className="header">
        <Box className="header-title">
          <Link to="/">
            <img src="logo_light.svg" alt="QKart-icon" />
          </Link>
        </Box>
        {children}
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={routeToExplore}
        >
          Back To explore
        </Button>
      </Box>
    );
  }

  return (
    <Box className="header">
      <Box className="header-title">
        <Link to="/">
          <img src="logo_light.svg" alt="QKart-icon" />
        </Link>
      </Box>
      {children}
      <Stack direction="row" spacing={1} alignItems="center">
        {localStorage.getItem("username") ? (
          <>
            <Avatar src="avatar.png" alt={localStorage.getItem("username") || "profile"} />
            <p className="username-text">{localStorage.getItem("username")}</p>
            <Button variant="contained" onClick={logout}>
              Logout
            </Button>
          </>
        ) : (
          <>
            <Button onClick={routeToLogin}>Login</Button>
            <Button variant="contained" onClick={routeToRegister}>
              Register
            </Button>
          </>
        )}
      </Stack>
    </Box>
  );
};

export default Header;
